export const UserIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.6666C12 11.1939 10.2091 9.99996 8 9.99996C5.79086 9.99996 4 11.1939 4 12.6666M8 7.99996C6.52724 7.99996 5.33333 6.80605 5.33333 5.33329C5.33333 3.86053 6.52724 2.66663 8 2.66663C9.47276 2.66663 10.6667 3.86053 10.6667 5.33329C10.6667 6.80605 9.47276 7.99996 8 7.99996Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaidIcon = ({ fill }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 10.25H3.5C2 10.25 1 9.5 1 7.75V4.25C1 2.5 2 1.75 3.5 1.75H8.5C10 1.75 11 2.5 11 4.25V7.75C11 9.5 10 10.25 8.5 10.25Z"
      stroke={fill}
      strokeWidth="0.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.5C6.82843 7.5 7.5 6.82843 7.5 6C7.5 5.17157 6.82843 4.5 6 4.5C5.17157 4.5 4.5 5.17157 4.5 6C4.5 6.82843 5.17157 7.5 6 7.5Z"
      stroke={fill}
      strokeWidth="0.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 3H3.5C2.81 3 2.25 3.56 2.25 4.25V5"
      stroke={fill}
      strokeWidth="0.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 3H8.5C9.19 3 9.75 3.56 9.75 4.25V5"
      stroke={fill}
      strokeWidth="0.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 9H3.5C2.81 9 2.25 8.44 2.25 7.75V7"
      stroke={fill}
      strokeWidth="0.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 9H8.5C9.19 9 9.75 8.44 9.75 7.75V7"
      stroke={fill}
      strokeWidth="0.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StaffMsgIcon = ({ fill }) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M15.5 12C15.5 12.5933 15.3241 13.1734 14.9944 13.6667C14.6648 14.1601 14.1962 14.5446 13.6481 14.7716C13.0999 14.9987 12.4967 15.0581 11.9147 14.9424C11.3328 14.8266 10.7982 14.5409 10.3787 14.1213C9.95912 13.7018 9.6734 13.1672 9.55765 12.5853C9.44189 12.0033 9.5013 11.4001 9.72836 10.8519C9.95543 10.3038 10.3399 9.83524 10.8333 9.50559C11.3266 9.17595 11.9067 9 12.5 9C13.2957 9 14.0587 9.31607 14.6213 9.87868C15.1839 10.4413 15.5 11.2044 15.5 12Z"
      fill={fill}
    />
    <path
      d="M12.5 8.2494C11.7583 8.2494 11.0333 8.46933 10.4166 8.88139C9.79992 9.29345 9.31927 9.87911 9.03544 10.5643C8.75161 11.2496 8.67735 12.0036 8.82204 12.731C8.96674 13.4584 9.32389 14.1266 9.84834 14.6511C10.3728 15.1755 11.041 15.5327 11.7684 15.6773C12.4958 15.822 13.2498 15.7478 13.9351 15.4639C14.6203 15.1801 15.2059 14.6995 15.618 14.0828C16.0301 13.4661 16.25 12.7411 16.25 11.9994C16.25 11.0048 15.8549 10.051 15.1516 9.34775C14.4484 8.64449 13.4946 8.2494 12.5 8.2494ZM12.5 14.2494C12.055 14.2494 11.62 14.1174 11.25 13.8702C10.8799 13.623 10.5916 13.2716 10.4213 12.8604C10.251 12.4493 10.2064 11.9969 10.2932 11.5604C10.38 11.124 10.5943 10.7231 10.909 10.4084C11.2237 10.0937 11.6246 9.87945 12.061 9.79263C12.4975 9.70582 12.9499 9.75037 13.361 9.92067C13.7722 10.091 14.1236 10.3794 14.3708 10.7494C14.618 11.1194 14.75 11.5544 14.75 11.9994C14.75 12.5961 14.5129 13.1684 14.091 13.5904C13.669 14.0123 13.0967 14.2494 12.5 14.2494ZM19.4103 14.9188C19.0881 15.6806 18.6421 16.3838 18.0903 17C17.9567 17.1446 17.7716 17.2308 17.575 17.2401C17.3784 17.2495 17.186 17.1811 17.0393 17.0498C16.8926 16.9185 16.8034 16.7348 16.791 16.5384C16.7786 16.3419 16.8439 16.1485 16.9728 15.9997C17.9576 14.9002 18.5021 13.476 18.5021 11.9999C18.5021 10.5238 17.9576 9.09958 16.9728 8.00003C16.9053 7.92696 16.853 7.84118 16.8189 7.7477C16.7848 7.65421 16.7697 7.55489 16.7744 7.4555C16.7791 7.35612 16.8036 7.25867 16.8463 7.16882C16.8891 7.07897 16.9492 6.99852 17.0234 6.93217C17.0975 6.86581 17.1841 6.81486 17.2781 6.7823C17.3721 6.74973 17.4717 6.7362 17.571 6.74248C17.6703 6.74877 17.7673 6.77475 17.8565 6.81891C17.9457 6.86307 18.0251 6.92453 18.0903 6.99971C19.0373 8.0594 19.6641 9.36613 19.8978 10.768C20.1314 12.1698 19.9624 13.6092 19.4103 14.9188ZM6.96874 9.66409C6.52622 10.7116 6.3905 11.8633 6.5774 12.985C6.76429 14.1068 7.26611 15.1523 8.02436 15.9997C8.15331 16.1485 8.2186 16.3419 8.20616 16.5384C8.19373 16.7348 8.10455 16.9185 7.95788 17.0498C7.81121 17.1811 7.6188 17.2495 7.42218 17.2401C7.22555 17.2308 7.04047 17.1446 6.90686 17C5.67554 15.6256 4.99465 13.8452 4.99465 11.9999C4.99465 10.1546 5.67554 8.37413 6.90686 6.99971C7.03951 6.85115 7.22575 6.76137 7.42459 6.75012C7.62344 6.73886 7.81861 6.80706 7.96718 6.93971C8.11574 7.07236 8.20552 7.2586 8.21677 7.45744C8.22803 7.65629 8.15983 7.85146 8.02718 8.00003C7.58468 8.49229 7.227 9.05463 6.96874 9.66409ZM23.75 11.9994C23.7545 14.9448 22.5998 17.7736 20.5353 19.8744C20.467 19.9474 20.3848 20.0061 20.2935 20.0468C20.2022 20.0876 20.1037 20.1098 20.0037 20.1119C19.9038 20.1141 19.8044 20.0962 19.7114 20.0594C19.6185 20.0226 19.5338 19.9676 19.4624 19.8975C19.391 19.8275 19.3344 19.744 19.2957 19.6517C19.2571 19.5595 19.2373 19.4605 19.2376 19.3605C19.2378 19.2605 19.258 19.1616 19.297 19.0695C19.336 18.9774 19.393 18.8941 19.4647 18.8244C21.2522 17.0032 22.2537 14.5532 22.2537 12.0013C22.2537 9.44937 21.2522 6.99937 19.4647 5.17815C19.3249 5.03618 19.2473 4.84451 19.2489 4.64531C19.2505 4.44611 19.3311 4.2557 19.4731 4.11596C19.6151 3.97623 19.8068 3.89861 20.006 3.9002C20.2052 3.90178 20.3956 3.98243 20.5353 4.1244C22.5998 6.22518 23.7545 9.05402 23.75 11.9994ZM5.5353 18.8225C5.60437 18.8928 5.65891 18.976 5.69582 19.0674C5.73273 19.1588 5.75128 19.2565 5.75041 19.3551C5.74954 19.4536 5.72926 19.551 5.69075 19.6418C5.65223 19.7325 5.59623 19.8147 5.52593 19.8838C5.45563 19.9528 5.37242 20.0074 5.28104 20.0443C5.18966 20.0812 5.09191 20.0998 4.99336 20.0989C4.89481 20.098 4.7974 20.0777 4.70669 20.0392C4.61598 20.0007 4.53374 19.9447 4.46468 19.8744C2.40047 17.773 1.2439 14.9451 1.2439 11.9994C1.2439 9.05373 2.40047 6.22583 4.46468 4.1244C4.53298 4.05138 4.61519 3.99275 4.70648 3.95196C4.79777 3.91117 4.89629 3.88905 4.99625 3.88689C5.09622 3.88474 5.1956 3.90259 5.28856 3.9394C5.38153 3.97622 5.46619 4.03125 5.53757 4.10126C5.60896 4.17127 5.66563 4.25484 5.70424 4.34707C5.74285 4.4393 5.76264 4.53832 5.76243 4.63831C5.76221 4.73829 5.74201 4.83723 5.70301 4.92929C5.664 5.02136 5.60698 5.10469 5.5353 5.1744C3.74774 6.99562 2.74628 9.44562 2.74628 11.9975C2.74628 14.5494 3.74774 16.9994 5.5353 18.8207V18.8225Z"
      fill={fill}
    />
  </svg>
);

export const ConfigIcon = ({ fill }) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5666 4.94862L13.3225 4.8128C13.2846 4.79171 13.2659 4.78113 13.2476 4.77016C13.0656 4.6611 12.9121 4.51042 12.8001 4.33015C12.7889 4.31201 12.7782 4.29299 12.7565 4.2554C12.7348 4.21785 12.7238 4.19882 12.7138 4.17999C12.6133 3.99244 12.559 3.78344 12.5557 3.57071C12.5554 3.54932 12.5555 3.52747 12.5562 3.48403L12.561 3.20052C12.5686 2.74684 12.5724 2.51929 12.5087 2.31508C12.452 2.13369 12.3573 1.96662 12.2308 1.82483C12.0878 1.66457 11.8898 1.55023 11.4935 1.32184L11.1643 1.13214C10.7691 0.904386 10.5714 0.790472 10.3615 0.747045C10.1759 0.708625 9.98435 0.710406 9.79939 0.751928C9.59063 0.798791 9.39543 0.915674 9.00524 1.14931L9.00303 1.15037L8.76715 1.29161C8.72985 1.31394 8.71097 1.3252 8.69228 1.33559C8.50676 1.43874 8.29965 1.49577 8.08749 1.50258C8.06611 1.50327 8.04436 1.50327 8.00087 1.50327C7.95765 1.50327 7.93497 1.50327 7.91363 1.50258C7.70102 1.49574 7.49348 1.4384 7.30767 1.33482C7.28895 1.32439 7.27042 1.31304 7.23305 1.2906L6.99566 1.14809C6.60282 0.912242 6.4061 0.794143 6.19618 0.747045C6.01047 0.705377 5.81825 0.704224 5.63194 0.743139C5.42157 0.787078 5.22384 0.901837 4.82839 1.13136L4.82663 1.13214L4.50152 1.32083L4.49792 1.32303C4.10603 1.55048 3.90961 1.66448 3.7678 1.82409C3.64196 1.96573 3.5479 2.13254 3.4916 2.31345C3.42796 2.51794 3.43135 2.74597 3.43902 3.2018L3.44378 3.4849C3.44451 3.52778 3.44576 3.54908 3.44544 3.57016C3.44229 3.78333 3.38724 3.99276 3.2865 4.18064C3.27653 4.19922 3.2658 4.2178 3.24436 4.25492C3.22291 4.29206 3.21252 4.31053 3.20139 4.32845C3.08891 4.50968 2.93476 4.66124 2.75155 4.77048C2.73343 4.78129 2.71433 4.79168 2.67681 4.81248L2.43577 4.94605C2.03472 5.1683 1.83425 5.27952 1.68837 5.4378C1.55932 5.57782 1.46183 5.7439 1.40233 5.92478C1.33506 6.12925 1.33512 6.35852 1.33616 6.81703L1.33701 7.19178C1.33804 7.64723 1.33946 7.8748 1.40688 8.07788C1.46652 8.25755 1.5633 8.42265 1.69163 8.56182C1.83668 8.71914 2.03516 8.82967 2.43316 9.05108L2.67206 9.18398C2.71271 9.2066 2.73317 9.21776 2.75278 9.22957C2.93432 9.33889 3.08726 9.49003 3.19879 9.67022C3.21084 9.68969 3.2224 9.7099 3.24553 9.7503C3.26837 9.79021 3.28006 9.81016 3.29062 9.83016C3.38841 10.0153 3.44076 10.221 3.44433 10.4303C3.44471 10.4529 3.44438 10.4758 3.44361 10.5218L3.43902 10.7935C3.4313 11.2509 3.42794 11.4798 3.49195 11.6849C3.54858 11.8663 3.64323 12.0333 3.76975 12.1751C3.91277 12.3354 4.11103 12.4496 4.50738 12.678L4.83652 12.8677C5.23175 13.0955 5.4293 13.2092 5.63913 13.2527C5.82476 13.2911 6.01643 13.2896 6.20139 13.2481C6.41044 13.2011 6.60632 13.0838 6.99762 12.8495L7.2335 12.7083C7.27082 12.686 7.28971 12.6748 7.30841 12.6644C7.49393 12.5612 7.70082 12.5039 7.91298 12.4971C7.93436 12.4964 7.95611 12.4964 7.9996 12.4964C8.04319 12.4964 8.06492 12.4964 8.08635 12.4971C8.29896 12.5039 8.50712 12.5614 8.69293 12.665C8.70928 12.6741 8.72566 12.684 8.75442 12.7012L9.00518 12.8518C9.39808 13.0877 9.59438 13.2054 9.80431 13.2525C9.99002 13.2942 10.1824 13.2959 10.3687 13.257C10.579 13.213 10.7771 13.0981 11.1724 12.8687L11.5024 12.6771C11.8945 12.4495 12.0912 12.3354 12.233 12.1758C12.3589 12.0341 12.453 11.8674 12.5093 11.6865C12.5725 11.4835 12.5687 11.2572 12.5611 10.8079L12.5562 10.5149C12.5555 10.4721 12.5554 10.4507 12.5557 10.4297C12.5589 10.2165 12.613 10.0069 12.7138 9.81904C12.7237 9.80049 12.7345 9.78177 12.7559 9.74477C12.7773 9.70764 12.7885 9.68912 12.7996 9.6712C12.9121 9.48997 13.0664 9.33828 13.2496 9.22903C13.2675 9.21836 13.2859 9.20815 13.3225 9.18785L13.3238 9.18726L13.5648 9.05369C13.9659 8.83144 14.1667 8.7201 14.3126 8.56182C14.4417 8.42181 14.539 8.25595 14.5985 8.07507C14.6654 7.87181 14.6649 7.64386 14.6638 7.19071L14.663 6.80792C14.6619 6.35247 14.6614 6.12493 14.594 5.92185C14.5343 5.74218 14.437 5.57707 14.3087 5.4379C14.1638 5.28074 13.965 5.17017 13.5678 4.94919L13.5666 4.94862Z"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33355 6.99997C5.33355 8.47273 6.52746 9.66664 8.00022 9.66664C9.47298 9.66664 10.6669 8.47273 10.6669 6.99997C10.6669 5.52722 9.47298 4.33331 8.00022 4.33331C6.52746 4.33331 5.33355 5.52722 5.33355 6.99997Z"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Add = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5 10H10M10 10H15M10 10V15M10 10V5"
        stroke={fill}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AdminDashboardIcon = ({ fill, stroke = "white" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3H4C3.44772 3 3 3.44772 3 4V7C3 7.55228 3.44772 8 4 8H6C6.55228 8 7 7.55228 7 7V4C7 3.44772 6.55228 3 6 3Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M12 3H10C9.44772 3 9 3.44772 9 4V5C9 5.55228 9.44772 6 10 6H12C12.5523 6 13 5.55228 13 5V4C13 3.44772 12.5523 3 12 3Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M6 10H4C3.44772 10 3 10.4477 3 11V12C3 12.5523 3.44772 13 4 13H6C6.55228 13 7 12.5523 7 12V11C7 10.4477 6.55228 10 6 10Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M12 8H10C9.44772 8 9 8.44772 9 9V12C9 12.5523 9.44772 13 10 13H12C12.5523 13 13 12.5523 13 12V9C13 8.44772 12.5523 8 12 8Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
    </svg>
  );
};

export const StaffReportsIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3538 4.1775L10.8538 1.6775C10.8073 1.63108 10.7521 1.59428 10.6914 1.56918C10.6307 1.54409 10.5657 1.5312 10.5 1.53125H5.5C5.23478 1.53125 4.98043 1.63661 4.79289 1.82414C4.60536 2.01168 4.5 2.26603 4.5 2.53125V3.53125H3.5C3.23478 3.53125 2.98043 3.63661 2.79289 3.82414C2.60536 4.01168 2.5 4.26603 2.5 4.53125V13.5312C2.5 13.7965 2.60536 14.0508 2.79289 14.2384C2.98043 14.4259 3.23478 14.5312 3.5 14.5312H10.5C10.7652 14.5312 11.0196 14.4259 11.2071 14.2384C11.3946 14.0508 11.5 13.7965 11.5 13.5312V12.5312H12.5C12.7652 12.5312 13.0196 12.4259 13.2071 12.2384C13.3946 12.0508 13.5 11.7965 13.5 11.5312V4.53125C13.5001 4.46557 13.4872 4.40052 13.4621 4.33983C13.437 4.27913 13.4002 4.22397 13.3538 4.1775ZM10.5 13.5312H3.5V4.53125H8.29313L10.5 6.73812V12.0212C10.5 12.025 10.5 12.0281 10.5 12.0312C10.5 12.0344 10.5 12.0375 10.5 12.0413V13.5312ZM12.5 11.5312H11.5V6.53125C11.5001 6.46557 11.4872 6.40052 11.4621 6.33983C11.437 6.27913 11.4002 6.22397 11.3538 6.1775L8.85375 3.6775C8.80728 3.63108 8.75212 3.59428 8.69143 3.56918C8.63073 3.54409 8.56568 3.5312 8.5 3.53125H5.5V2.53125H10.2931L12.5 4.73813V11.5312ZM9 9.53125C9 9.66386 8.94732 9.79104 8.85355 9.8848C8.75979 9.97857 8.63261 10.0312 8.5 10.0312H5.5C5.36739 10.0312 5.24021 9.97857 5.14645 9.8848C5.05268 9.79104 5 9.66386 5 9.53125C5 9.39864 5.05268 9.27146 5.14645 9.1777C5.24021 9.08393 5.36739 9.03125 5.5 9.03125H8.5C8.63261 9.03125 8.75979 9.08393 8.85355 9.1777C8.94732 9.27146 9 9.39864 9 9.53125ZM9 11.5312C9 11.6639 8.94732 11.791 8.85355 11.8848C8.75979 11.9786 8.63261 12.0312 8.5 12.0312H5.5C5.36739 12.0312 5.24021 11.9786 5.14645 11.8848C5.05268 11.791 5 11.6639 5 11.5312C5 11.3986 5.05268 11.2715 5.14645 11.1777C5.24021 11.0839 5.36739 11.0312 5.5 11.0312H8.5C8.63261 11.0312 8.75979 11.0839 8.85355 11.1777C8.94732 11.2715 9 11.3986 9 11.5312Z"
      fill={fill}
    />
  </svg>
);

export const StaffProfileIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 14.7667C11.3333 12.9258 9.84095 11.4334 8 11.4334C6.15905 11.4334 4.66667 12.9258 4.66667 14.7667M11.3333 14.7667H11.8687C12.614 14.7667 12.9867 14.7667 13.2716 14.6215C13.5225 14.4937 13.727 14.2892 13.8548 14.0383C14 13.7534 14 13.3807 14 12.6355V4.898C14 4.15272 14 3.77952 13.8548 3.49459C13.727 3.24371 13.5225 3.03988 13.2716 2.91205C12.9864 2.76672 12.6135 2.76672 11.8668 2.76672H4.13346C3.38673 2.76672 3.01308 2.76672 2.72786 2.91205C2.47698 3.03988 2.27316 3.24371 2.14532 3.49459C2 3.7798 2 4.15345 2 4.90019V12.6335C2 13.3803 2 13.7531 2.14532 14.0383C2.27316 14.2892 2.47698 14.4937 2.72786 14.6215C3.0128 14.7667 3.386 14.7667 4.13127 14.7667H4.66667M11.3333 14.7667H4.66667M8 9.43339C6.89543 9.43339 6 8.53796 6 7.43339C6 6.32882 6.89543 5.43339 8 5.43339C9.10457 5.43339 10 6.32882 10 7.43339C10 8.53796 9.10457 9.43339 8 9.43339Z"
      stroke={fill}
    />
  </svg>
);

export const InventoryIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 3.03125H2C1.73478 3.03125 1.48043 3.13661 1.29289 3.32414C1.10536 3.51168 1 3.76603 1 4.03125V5.53125C1 5.79647 1.10536 6.05082 1.29289 6.23836C1.48043 6.42589 1.73478 6.53125 2 6.53125V12.0312C2 12.2965 2.10536 12.5508 2.29289 12.7384C2.48043 12.9259 2.73478 13.0312 3 13.0312H13C13.2652 13.0312 13.5196 12.9259 13.7071 12.7384C13.8946 12.5508 14 12.2965 14 12.0312V6.53125C14.2652 6.53125 14.5196 6.42589 14.7071 6.23836C14.8946 6.05082 15 5.79647 15 5.53125V4.03125C15 3.76603 14.8946 3.51168 14.7071 3.32414C14.5196 3.13661 14.2652 3.03125 14 3.03125ZM13 12.0312H3V6.53125H13V12.0312ZM14 5.53125H2V4.03125H14V5.53125ZM6 8.53125C6 8.39864 6.05268 8.27146 6.14645 8.1777C6.24021 8.08393 6.36739 8.03125 6.5 8.03125H9.5C9.63261 8.03125 9.75979 8.08393 9.85355 8.1777C9.94732 8.27146 10 8.39864 10 8.53125C10 8.66386 9.94732 8.79104 9.85355 8.8848C9.75979 8.97857 9.63261 9.03125 9.5 9.03125H6.5C6.36739 9.03125 6.24021 8.97857 6.14645 8.8848C6.05268 8.79104 6 8.66386 6 8.53125Z"
      fill={fill}
    />
  </svg>
);

export const AdminLoanIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.33398 2.76672H9.66732C9.93253 2.76672 10.1869 2.87208 10.3744 3.05962C10.562 3.24715 10.6673 3.50151 10.6673 3.76672C10.6673 4.38556 10.4215 4.97905 9.9839 5.41664C9.54631 5.85422 8.95282 6.10006 8.33398 6.10006H7.66732C7.04848 6.10006 6.45499 5.85422 6.0174 5.41664C5.57982 4.97905 5.33398 4.38556 5.33398 3.76672C5.33398 3.50151 5.43934 3.24715 5.62688 3.05962C5.81441 2.87208 6.06877 2.76672 6.33398 2.76672Z"
      stroke={fill}
    />
    <path
      d="M2.66699 12.1001V11.4334C2.66699 10.0189 3.2289 8.66239 4.22909 7.66219C5.22928 6.662 6.58584 6.1001 8.00032 6.1001C9.41481 6.1001 10.7714 6.662 11.7716 7.66219C12.7718 8.66239 13.3337 10.0189 13.3337 11.4334V12.1001C13.3337 12.8073 13.0527 13.4856 12.5526 13.9857C12.0525 14.4858 11.3742 14.7668 10.667 14.7668H5.33366C4.62641 14.7668 3.94814 14.4858 3.44804 13.9857C2.94794 13.4856 2.66699 12.8073 2.66699 12.1001Z"
      stroke={fill}
    />
  </svg>
);

export const RequestIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 4.03125V12.0312C2.5 12.2965 2.60536 12.5508 2.79289 12.7384C2.98043 12.9259 3.23478 13.0312 3.5 13.0312H13.5C13.6326 13.0312 13.7598 12.9786 13.8536 12.8848C13.9473 12.791 14 12.6639 14 12.5312V5.53125C14 5.39864 13.9473 5.27146 13.8536 5.1777C13.7598 5.08393 13.6326 5.03125 13.5 5.03125H3.5C3.23478 5.03125 2.98043 4.92589 2.79289 4.73836C2.60536 4.55082 2.5 4.29647 2.5 4.03125ZM2.5 4.03125C2.5 3.76603 2.60536 3.51168 2.79289 3.32414C2.98043 3.13661 3.23478 3.03125 3.5 3.03125H12"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4 9.03125C11.4 9.11409 11.3328 9.18125 11.25 9.18125C11.1672 9.18125 11.1 9.11409 11.1 9.03125C11.1 8.94841 11.1672 8.88125 11.25 8.88125C11.3328 8.88125 11.4 8.94841 11.4 9.03125Z"
      fill={fill}
      stroke={fill}
      strokeWidth="1.2"
    />
  </svg>
);

export const PerformanceIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.69792L7.33333 9.36458L6 8.03125M8 14.0313C4.68629 14.0313 2 11.345 2 8.03125C2 4.71754 4.68629 2.03125 8 2.03125C11.3137 2.03125 14 4.71754 14 8.03125C14 11.345 11.3137 14.0313 8 14.0313Z"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeaveMgtIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5.43339V8.76672H11.3333M8 14.7667C4.68629 14.7667 2 12.0804 2 8.76672C2 5.45302 4.68629 2.76672 8 2.76672C11.3137 2.76672 14 5.45302 14 8.76672C14 12.0804 11.3137 14.7667 8 14.7667Z"
      stroke={fill}
    />
  </svg>
);

export const AdminMedicalIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99967 12.1001H9.99967M5.99967 10.1001H9.99967M8.66659 2.7673C8.6029 2.76672 8.53126 2.76672 8.44948 2.76672H5.46647C4.71973 2.76672 4.34609 2.76672 4.06087 2.91205C3.80999 3.03988 3.60616 3.24371 3.47833 3.49459C3.33301 3.7798 3.33301 4.15345 3.33301 4.90019V12.6335C3.33301 13.3803 3.33301 13.7534 3.47833 14.0386C3.60616 14.2895 3.80999 14.4937 4.06087 14.6215C4.34581 14.7667 4.71901 14.7667 5.4643 14.7667L10.5351 14.7667C11.2803 14.7667 11.653 14.7667 11.9379 14.6215C12.1888 14.4937 12.3933 14.2895 12.5212 14.0386C12.6663 13.7537 12.6663 13.3811 12.6663 12.6358V6.98385C12.6663 6.90207 12.6663 6.83041 12.6657 6.76672M8.66659 2.7673C8.8569 2.76904 8.97682 2.7761 9.09179 2.8037C9.22784 2.83637 9.35824 2.89023 9.47754 2.96334C9.61205 3.04577 9.72755 3.16127 9.95801 3.39172L12.0417 5.47538C12.2723 5.70598 12.3869 5.82096 12.4694 5.95552C12.5425 6.07482 12.5966 6.20489 12.6292 6.34094C12.6568 6.45591 12.664 6.57642 12.6657 6.76672M8.66659 2.7673L8.66634 4.63353C8.66634 5.38027 8.66634 5.75349 8.81167 6.03871C8.9395 6.28959 9.14332 6.49371 9.39421 6.62154C9.67914 6.76672 10.0523 6.76672 10.7976 6.76672H12.6657"
      stroke={fill}
    />
  </svg>
);

export const StaffScheduleIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5.43339V8.76672H11.3333M8 14.7667C4.68629 14.7667 2 12.0804 2 8.76672C2 5.45302 4.68629 2.76672 8 2.76672C11.3137 2.76672 14 5.45302 14 8.76672C14 12.0804 11.3137 14.7667 8 14.7667Z"
      stroke={fill}
    />
  </svg>
);

export const AdminMsgIcon = ({ fill }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.76576 7.35739L2.26291 7.3041C2.24181 7.10723 2.22852 6.91744 2.22852 6.72456C2.22852 3.33769 5.17676 0.53125 8.86435 0.53125C12.5519 0.53125 15.5002 3.33769 15.5002 6.72456C15.5002 8.58818 14.6388 10.3055 13.103 11.488C12.9626 11.5961 12.8899 11.7704 12.9119 11.9462L13.1647 13.9677C13.1648 13.9683 13.1649 13.9688 13.1649 13.9693C13.2017 14.2866 13.0646 14.5764 12.8016 14.7475C12.6709 14.8312 12.5188 14.876 12.3727 14.876C12.2286 14.876 12.0882 14.8392 11.9617 14.7624L11.9617 14.7624L11.9574 14.7598L8.97049 12.9879C8.89675 12.9441 8.813 12.9201 8.72728 12.918C8.42942 12.9109 8.13814 12.8898 7.86588 12.849L7.86498 12.8488C7.83944 12.8451 7.8202 12.8292 7.81146 12.8065C7.80629 12.793 7.80662 12.7843 7.80755 12.779C7.80851 12.7735 7.81137 12.7646 7.82121 12.7531C8.38916 12.0908 8.68652 11.2909 8.68652 10.4398C8.68652 8.32538 6.83815 6.67126 4.6484 6.67126C3.82861 6.67126 3.03356 6.89669 2.35968 7.33868C2.34804 7.34572 2.33754 7.34847 2.32862 7.3491C2.32026 7.34968 2.31014 7.34862 2.29816 7.34379C2.28727 7.33791 2.27811 7.3298 2.27177 7.32124C2.26514 7.31229 2.26304 7.30502 2.26246 7.30006L1.76576 7.35739ZM1.76576 7.35739C1.78811 7.55097 1.91473 7.71479 2.08605 7.79669L13.0729 15.1675C13.4974 14.8921 13.7209 14.4156 13.6613 13.9093L13.408 11.8841C15.0616 10.611 16.0002 8.74968 16.0002 6.72456C16.0002 3.0317 12.7973 0.03125 8.86435 0.03125C4.93145 0.03125 1.72852 3.0317 1.72852 6.72456C1.72852 6.94048 1.74342 7.14893 1.76576 7.35739ZM8.40972 12.0699C8.32935 12.2306 8.34136 12.4221 8.44118 12.5714C8.53864 12.7173 8.70518 12.8011 8.87979 12.7931C8.88626 12.7974 8.89284 12.8015 8.8995 12.8054L12.0157 14.6564C12.1401 14.7334 12.2826 14.7709 12.4293 14.7583C12.5657 14.7466 12.6709 14.6948 12.7393 14.6504C12.8905 14.5543 13.0944 14.327 13.0472 13.9784L12.7579 11.635C12.7553 11.6036 12.7687 11.5798 12.7842 11.5676C14.4259 10.415 15.3829 8.64477 15.3829 6.70966C15.3829 3.32356 12.4262 0.633139 8.86435 0.633139C5.43599 0.633139 2.5674 3.13098 2.35436 6.34155C2.34305 6.51192 2.41947 6.67629 2.55703 6.77745C2.69458 6.87861 2.87425 6.90259 3.03351 6.84103C3.53678 6.64653 4.07913 6.53961 4.64095 6.53961C6.96312 6.53961 8.79638 8.30895 8.79638 10.4249H8.79634L8.79641 10.4305C8.8029 11.001 8.667 11.5556 8.40972 12.0699ZM12.5442 13.8075L12.5378 13.8036C12.54 13.8049 12.5421 13.8062 12.5442 13.8075Z"
      stroke={fill}
      strokeLinejoin="round"
    />
    <path
      d="M2.19481 15.4484L2.19252 15.4469C2.01607 15.3332 1.92732 15.146 1.94895 14.9442L2.09731 13.8023C2.11962 13.6305 2.05149 13.4595 1.91722 13.3501C1.02309 12.6219 0.5 11.5484 0.5 10.4321C0.5 9.15866 1.16608 7.95924 2.30217 7.2354L2.30218 7.23542L2.30605 7.2329C2.99033 6.78799 3.80401 6.54688 4.65543 6.54688C6.97759 6.54688 8.81085 8.31622 8.81085 10.4321C8.81085 11.2941 8.49696 12.1472 7.91775 12.8248L7.9177 12.8247L7.91218 12.8314C7.16773 13.7336 6.04712 14.2699 4.79574 14.3102C4.71138 14.3129 4.62907 14.337 4.5565 14.3801L2.74009 15.459C2.73994 15.4591 2.73978 15.4592 2.73962 15.4593C2.65697 15.508 2.56695 15.531 2.47297 15.531C2.37341 15.531 2.28255 15.5056 2.19481 15.4484ZM2.84 15.2548L4.61797 14.1989C4.63678 14.1881 4.64742 14.186 4.6494 14.1857C5.88087 14.1853 7.06048 13.6589 7.81766 12.7404C8.37958 12.0755 8.6861 11.2785 8.6861 10.4247C8.6861 8.31701 6.83695 6.66367 4.64798 6.66367C3.82735 6.66367 3.0315 6.88952 2.35715 7.33243C1.2716 8.0287 0.609857 9.17914 0.609857 10.4321C0.609857 11.6377 1.20243 12.7342 2.2256 13.4342C2.23527 13.4411 2.24172 13.4494 2.24592 13.4588C2.25005 13.468 2.25283 13.4802 2.25169 13.4954L2.08878 14.761C2.06437 14.9507 2.15027 15.1377 2.31007 15.2427C2.46987 15.3477 2.67558 15.3524 2.84 15.2548Z"
      stroke={fill}
      strokeLinejoin="round"
    />
    <path
      d="M6 5.03125H12"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M8 8.03125L12 8.03125"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M3 9.53125H6"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M4 11.5312L6 11.5312"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export const LogoutIcon = ({ fill }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M12.1797 14.62L14.7397 12.06L12.1797 9.5"
          stroke={fill}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 12.0596H14.67"
          stroke={fill}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M12.5 4C16.92 4 20.5 7 20.5 12C20.5 17 16.92 20 12.5 20"
        stroke={fill}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DashboardIcon = ({ fill }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 10.9V4.1C22.5 2.6 21.86 2 20.27 2H16.23C14.64 2 14 2.6 14 4.1V10.9C14 12.4 14.64 13 16.23 13H20.27C21.86 13 22.5 12.4 22.5 10.9Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M22.5 19.9V18.1C22.5 16.6 21.86 16 20.27 16H16.23C14.64 16 14 16.6 14 18.1V19.9C14 21.4 14.64 22 16.23 22H20.27C21.86 22 22.5 21.4 22.5 19.9Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 13.1V19.9C11 21.4 10.36 22 8.77 22H4.73C3.14 22 2.5 21.4 2.5 19.9V13.1C2.5 11.6 3.14 11 4.73 11H8.77C10.36 11 11 11.6 11 13.1Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11 4.1V5.9C11 7.4 10.36 8 8.77 8H4.73C3.14 8 2.5 7.4 2.5 5.9V4.1C2.5 2.6 3.14 2 4.73 2H8.77C10.36 2 11 2.6 11 4.1Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileIcon = ({ fill }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 12C15.2614 12 17.5 9.76142 17.5 7C17.5 4.23858 15.2614 2 12.5 2C9.73858 2 7.5 4.23858 7.5 7C7.5 9.76142 9.73858 12 12.5 12Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M21.0899 22C21.0899 18.13 17.2399 15 12.4999 15C7.75991 15 3.90991 18.13 3.90991 22"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ScheduleIcon = ({ fill }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1599 10.4395L21.1799 14.6195C20.3399 18.2295 18.6799 19.6895 15.5599 19.3895C15.0599 19.3495 14.5199 19.2595 13.9399 19.1195L12.2599 18.7195C8.08994 17.7295 6.79994 15.6695 7.77994 11.4895L8.75994 7.29952C8.95994 6.44952 9.19994 5.70952 9.49994 5.09952C10.6699 2.67952 12.6599 2.02952 15.9999 2.81952L17.6699 3.20952C21.8599 4.18952 23.1399 6.25952 22.1599 10.4395Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M15.5601 19.3896C14.9401 19.8096 14.1601 20.1596 13.2101 20.4696L11.6301 20.9896C7.6601 22.2696 5.5701 21.1996 4.2801 17.2296L3.0001 13.2796C1.7201 9.30961 2.7801 7.20961 6.7501 5.92961L8.3301 5.40961C8.7401 5.27961 9.1301 5.16961 9.5001 5.09961C9.2001 5.70961 8.9601 6.44961 8.7601 7.29961L7.7801 11.4896C6.8001 15.6696 8.0901 17.7296 12.2601 18.7196L13.9401 19.1196C14.5201 19.2596 15.0601 19.3496 15.5601 19.3896Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M13.1399 8.53027L17.9899 9.76027"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M12.1599 12.4004L15.0599 13.1404"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LoanIcon = ({ fill }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M14.7617 15.4385H9.76172"
          stroke={fill}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2617 12.998V17.998"
          stroke={fill}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M13.16 2.51814L13.13 2.58814L10.23 9.31814H7.37996C6.69996 9.31814 6.04996 9.45814 5.45996 9.70814L7.20996 5.52814L7.24996 5.42814L7.31996 5.26814C7.33996 5.20814 7.35996 5.14814 7.38996 5.09814C8.69996 2.06814 10.18 1.37814 13.16 2.51814Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.55 9.51856C18.1 9.37856 17.62 9.31855 17.14 9.31855H10.23L13.13 2.58855L13.16 2.51855C13.31 2.56855 13.45 2.63855 13.6 2.69855L15.81 3.62855C17.04 4.13855 17.9 4.66855 18.42 5.30855C18.52 5.42855 18.6 5.53855 18.67 5.66855C18.76 5.80855 18.83 5.94855 18.87 6.09855C18.91 6.18855 18.94 6.27855 18.96 6.35855C19.23 7.19855 19.07 8.22856 18.55 9.51856Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0217 14.1984V16.1484C22.0217 16.3484 22.0117 16.5484 22.0017 16.7484C21.8117 20.2384 19.8617 21.9984 16.1617 21.9984H8.36172C8.12172 21.9984 7.88172 21.9784 7.65172 21.9484C4.47172 21.7384 2.77172 20.0384 2.56172 16.8584C2.53172 16.6284 2.51172 16.3884 2.51172 16.1484V14.1984C2.51172 12.1884 3.73172 10.4584 5.47172 9.70836C6.07172 9.45836 6.71172 9.31836 7.39172 9.31836H17.1517C17.6417 9.31836 18.1217 9.38836 18.5617 9.51836C20.5517 10.1284 22.0217 11.9884 22.0217 14.1984Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.21 5.52832L5.46 9.70832C3.72 10.4583 2.5 12.1883 2.5 14.1983V11.2683C2.5 8.42832 4.52 6.05832 7.21 5.52832Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M22.0186 11.2677V14.1977C22.0186 11.9977 20.5586 10.1277 18.5586 9.52766C19.0786 8.22766 19.2286 7.20766 18.9786 6.35766C18.9586 6.26766 18.9286 6.17766 18.8886 6.09766C20.7486 7.05766 22.0186 9.02766 22.0186 11.2677Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeaveIcon = ({ fill }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 12C15.2614 12 17.5 9.76142 17.5 7C17.5 4.23858 15.2614 2 12.5 2C9.73858 2 7.5 4.23858 7.5 7C7.5 9.76142 9.73858 12 12.5 12Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7101 15.74L16.17 19.2801C16.03 19.4201 15.9 19.68 15.87 19.87L15.68 21.22C15.61 21.71 15.95 22.05 16.44 21.98L17.79 21.79C17.98 21.76 18.25 21.63 18.38 21.49L21.92 17.95C22.53 17.34 22.82 16.63 21.92 15.73C21.03 14.84 20.3201 15.13 19.7101 15.74Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2002 16.25C19.5002 17.33 20.3402 18.17 21.4202 18.47"
        stroke={fill}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M3.90991 22C3.90991 18.13 7.75994 15 12.4999 15C13.5399 15 14.5399 15.15 15.4699 15.43"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MedicalIcon = ({ fill }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 15V9C22.5 4 20.5 2 15.5 2H9.5C4.5 2 2.5 4 2.5 9V15C2.5 20 4.5 22 9.5 22H15.5C20.5 22 22.5 20 22.5 15Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M17.5 16.75H14.4L16.02 14.96C16.82 14.07 17.26 12.94 17.26 11.78C17.26 10.58 16.76 9.43002 15.87 8.58002C14.98 7.73002 13.77 7.25 12.5 7.25C11.24 7.25 10.03 7.73002 9.13 8.58002C8.24 9.43002 7.73999 10.58 7.73999 11.78C7.73999 12.95 8.17998 14.08 8.97998 14.96L10.6 16.75H7.5"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PerfIcon = ({ fill }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 22C18 22 22.5 17.5 22.5 12C22.5 6.5 18 2 12.5 2C7 2 2.5 6.5 2.5 12C2.5 17.5 7 22 12.5 22Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M8.25 11.9999L11.08 14.8299L16.75 9.16992"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
